import * as React from 'react'
import { cn } from '@/lib/utils'

/**
 * 统一骨架原语 — 页面自拼 animate-pulse 条的收敛点。
 * 颜色统一 bg-enterprise-border：在 bg-enterprise-bg 与 bg-enterprise-surface
 * 两种底上都可见（Models/Datasets 曾用 surface 打 surface，加载时整块隐形）。
 * variant:
 *  - pulse（默认）— 低闪烁静默占位，适合会很快被内容替换的块
 *  - shimmer — 高光扫过，适合首屏主列表这类等待感明显的位置
 */
export type SkeletonVariant = 'pulse' | 'shimmer'

export function Skeleton({
  variant = 'pulse',
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { variant?: SkeletonVariant }) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'rounded-none',
        variant === 'shimmer' ? 'skeleton-shimmer' : 'bg-enterprise-border motion-safe:animate-pulse motion-reduce:animate-none',
        className,
      )}
      {...props}
    />
  )
}
